import React, {FC, createContext, useContext, useEffect, useState} from 'react'
import {WithChildren, toAbsoluteUrl} from '../helpers'
import { getListLanguages } from '../../app/common/utils/request'
import { I18nProvider } from './i18nProvider'

const I18N_CONFIG_KEY = process.env.REACT_APP_I18N_CONFIG_KEY || 'i18nConfig'

type Props = {
  selectedLang: 'de' | 'en' | 'es' | 'fr' | 'ja' | 'zh',
  refetchLangList: Function,
  langueList: any[],
  updateLangState: Function
}
const initialState: Props = {
  selectedLang: 'fr',
  refetchLangList: () => {},
  langueList: [],
  updateLangState: () => {}
}

function getConfig(): Props {
  const ls = localStorage.getItem(I18N_CONFIG_KEY)
  if (ls) {
    try {
      return JSON.parse(ls) as Props
    } catch (er) {
      console.error(er)
    }
  }
  return initialState
}

// Side effect
export function setLanguage(lang: string) {
  localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: lang}))
  // window.location.reload()
}

const I18nContext = createContext<Props>(initialState)

const useLang = () => {
  return useContext(I18nContext).selectedLang
}

const useLangList = () => {
  return useContext(I18nContext).langueList
}

const useRefetchLangList = () => {
  return useContext(I18nContext).refetchLangList
}
const useI18N = () => {
  return useContext(I18nContext)
}
const getFlag = (code: String) => {
  console.log(code);
  switch (code.toLocaleLowerCase()) {
    case 'en':
      return toAbsoluteUrl('/media/flags/united-states.svg')
    case 'fr':
      return toAbsoluteUrl('/media/flags/france.svg')  
    case 'es':
      return toAbsoluteUrl('/media/flags/spain.svg') 
    case 'zh':
      return toAbsoluteUrl('/media/flags/china.svg')   
    default:
      return ''  
  }
}
//fory

const MetronicI18nProvider: FC<WithChildren> = ({children}) => {
  // const ls = localStorage.getItem(I18N_CONFIG_KEY)
  const lang = getConfig()
  const [langList, setLangList] = useState<Array<any>>([])
  const [, setSelectedLocale] = useState<string>(lang?.selectedLang)
  console.log(process.env.REACT_APP_API_URL);
  useEffect(() => {
    refetchLangList()
  },[]);  

  const refetchLangList = async() => {
    const responseListLang = await getListLanguages();
    if(responseListLang && responseListLang.data && responseListLang?.data?.Status?.Success && responseListLang?.data?.data) {
      const languesList =responseListLang?.data?.data.map((langues: any) => {
          return {
            lang: langues?.Code,
            flag: getFlag(langues?.Code?.toLocaleUpperCase()),
            name: langues?.Name,
          }
      })
      setLangList(languesList)
    }
  }
  const updateLangState = (locale: string) => {
    console.log('locale',locale)
    setLanguage(locale)
    setSelectedLocale(locale)
  }
    return (
      <I18nContext.Provider 
        value={{
        selectedLang: lang.selectedLang,
        refetchLangList:refetchLangList,
        langueList:langList,
        updateLangState: updateLangState
        }}
        >
          <I18nProvider>
             {children}
          </I18nProvider>
      </I18nContext.Provider>
    )
}

export {MetronicI18nProvider, useLang, useLangList, useRefetchLangList, useI18N}
